// https://github.com/axios/axios/issues/734

import { getConfig } from '../config';
import { PRODUCTION_ENV } from '../config/constants';
import { createHttpClient } from '@wix/http-client';

export const COMMON_TRANSPORT_CONFIG = {
  withCredentials: true,
};

const DEFAULT_CONFIG = {
  ...COMMON_TRANSPORT_CONFIG,
  baseURL: getConfig().api.baseUrl,
};

export const transport = createHttpClient(DEFAULT_CONFIG);

if (process.env.NODE_ENV !== PRODUCTION_ENV) {
  global.transport = transport;
}
